import base from 'api/base'

const baseUrl = process.env.VUE_APP_API_GATEWAY_BASE_URL
const organizationURI = 'organization/v1'

export default {
    get (uri, params, options) {
        return base.get(`${baseUrl}/${organizationURI}/${uri}`, params, options)
    },
    put (uri, body, params, options) {
        return base.put(`${baseUrl}/${organizationURI}/${uri}`, body, params, options)
    },
    patch (uri, body, params, options) {
        return base.patch(`${baseUrl}/${organizationURI}/${uri}`, body, params, options)
    },
    delete (uri, params) {
        return base.delete(`${baseUrl}/${organizationURI}/${uri}`, params)
    },
    post (uri, body, params, options) {
        return base.post(`${baseUrl}/${organizationURI}/${uri}`, body, params, options)
    },
}
